/** Shared destinations and copy keys for homepage and sidebar Quick Start entries. */
export const EXPLORE_QUICK_START_ITEMS = [
  { labelKey: 'kagemane', iconSrc: '/quick-start/kagemane.png', templateId: null },
  { labelKey: 'virtualTryOn', iconSrc: '/quick-start/virtual-try-on.png', templateId: null },
  { labelKey: 'outfitExtension', iconSrc: '/quick-start/outfit-extension.png', templateId: '1d3c0538-49cb-4c4d-a0f6-6d2b1f7b82e5' },
  { labelKey: 'silhouetteExtension', iconSrc: '/quick-start/silhouette-extension.png', templateId: '8f5ddf57-29d6-47df-9a91-bf7cbf1c8d41' },
  { labelKey: 'whiteBackground', iconSrc: '/quick-start/white-background.png', templateId: '85a30854-0450-4555-a888-53c7184a24a3' },
  { labelKey: 'lookbook', iconSrc: '/quick-start/lookbook.png', templateId: 'fc9418f7-08f6-4d5c-97db-253d17212000' },
] as const satisfies readonly {
  labelKey: string;
  iconSrc: string;
  templateId: string | null;
}[];

export function getExploreQuickStartHref(labelKey: string, templateId: string | null): string | null {
  if (labelKey === 'virtualTryOn') return null;
  if (labelKey === 'cinemaStudio') return '/cinema-studio';
  return templateId ? `/t/${encodeURIComponent(templateId)}` : '/kagemane';
}
